export * from './Wc';
//# sourceMappingURL=index.js.map